export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-geo/src/constant.js
// module id = d/uL
// module chunks = 0